/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForward30 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.707 1.293 15.414 5l-3.707 3.707-1.414-1.414 1.279-1.28a7 7 0 1 0 7.424 7.228L19 13h2a9 9 0 1 1-9.406-8.991l-1.301-1.302zm-.396 9.254v.927l-1.548 1.584c.582.066 1.03.268 1.345.608s.473.763.473 1.273c0 .45-.102.838-.306 1.165s-.496.578-.877.752-.833.261-1.355.261c-.342 0-.672-.034-.99-.103s-.6-.17-.846-.302v-1.197c.246.132.531.235.855.31s.633.113.927.113c.426 0 .753-.087.981-.261.228-.174.342-.423.342-.747 0-.306-.088-.543-.265-.711-.178-.168-.437-.252-.779-.252-.312 0-.618.057-.918.171l-.441-.738 1.62-1.71H7.324v-1.143zm3.411-.117c1.674 0 2.511 1.101 2.511 3.303 0 1.104-.213 1.944-.639 2.52s-1.05.864-1.872.864-1.446-.288-1.872-.864-.639-1.416-.639-2.52c0-2.202.837-3.303 2.511-3.303zm0 1.143c-.384 0-.664.172-.842.517s-.265.893-.265 1.643c0 .762.09 1.326.27 1.692s.459.549.837.549.657-.183.837-.549.27-.93.27-1.692c0-.75-.088-1.297-.266-1.643s-.457-.517-.841-.517z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgForward30 as Forward30 };
